import { CLOVER_FORBIDDEN_LOG_DATA_KEYS } from './clover/clover-logging-redaction.types';
import { VALOR_FORBIDDEN_LOG_DATA_KEYS } from './valor/valor-logging.types';

export const IPG_FORBIDDEN_LOG_DATA_KEYS = [
    ...CLOVER_FORBIDDEN_LOG_DATA_KEYS,
    ...VALOR_FORBIDDEN_LOG_DATA_KEYS,
] as const;

export type IpgForbiddenLogDataKey = (typeof IPG_FORBIDDEN_LOG_DATA_KEYS)[number];
